import { supabase } from '../lib/supabase';

export interface EditorialDirective {
  id: string;
  instruction: string;
  priority: number;
  is_active: boolean;
  created_at: string;
}

export interface EditorialLog {
  id: string;
  topic: string;
  generated_draft?: any;
  editor_feedback?: string;
  status: 'drafting' | 'reviewing' | 'approved' | 'rejected';
  score: number;
  attempt_count: number;
  post_id?: string | null;
  created_at: string;
}

export interface AgentJob {
  id: string;
  action: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  result_post_id?: string | null;
  result_post_slug?: string | null;
  result_post_title?: string | null;
  error_message?: string | null;
  created_at: string;
  updated_at: string;
}

export const aiDirectivesService = {
  // دریافت لیست تمام دستورات تحریریه
  async getDirectives(): Promise<EditorialDirective[]> {
    const { data, error } = await supabase
      .from('ai_editorial_directives')
      .select('*')
      .order('priority', { ascending: false })
      .order('created_at', { ascending: false });

    if (error) throw error;
    return (data || []) as EditorialDirective[];
  },

  // ثبت دستور جدید
  async addDirective(instruction: string, priority = 1): Promise<EditorialDirective> {
    const { data, error } = await supabase
      .from('ai_editorial_directives')
      .insert([{ instruction, priority, is_active: true }])
      .select()
      .single();

    if (error) throw error;
    return data as EditorialDirective;
  },

  // تغییر وضعیت فعال/غیرفعال بودن دستور
  async toggleDirective(id: string, is_active: boolean): Promise<void> {
    const { error } = await supabase
      .from('ai_editorial_directives')
      .update({ is_active, updated_at: new Date().toISOString() })
      .eq('id', id);

    if (error) throw error;
  },

  // حذف دستور
  async deleteDirective(id: string): Promise<void> {
    const { error } = await supabase
      .from('ai_editorial_directives')
      .delete()
      .eq('id', id);

    if (error) throw error;
  },

  // دریافت آخرین لاگ‌های تولید و نظارت ایجنت‌ها
  async getEditorialLogs(limit = 10): Promise<EditorialLog[]> {
    const { data, error } = await supabase
      .from('ai_editorial_logs')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(limit);

    if (error) throw error;
    return (data || []) as EditorialLog[];
  },

  // ۱. درخواست دستی تولید فوری مقاله (جایگزین npm run generate-now از پنل ادمین)
  async triggerManualGeneration(): Promise<AgentJob> {
    const { data, error } = await supabase
      .from('ai_agent_jobs')
      .insert([
        {
          action: 'generate_article',
          status: 'pending',
        },
      ])
      .select()
      .single();

    if (error) throw error;
    return data as AgentJob;
  },

  // ۲. استعلام وضعیت جاب
  async getJobStatus(jobId: string): Promise<AgentJob> {
    const { data, error } = await supabase
      .from('ai_agent_jobs')
      .select('*')
      .eq('id', jobId)
      .single();

    if (error) throw error;
    return data as AgentJob;
  },
};
